(function () {
  'use strict';

  var rail = document.querySelector('[data-film-rail]');
  if (!rail) return;

  var stage = rail.querySelector('[data-film]');
  var canvas = rail.querySelector('[data-film-canvas]');
  var poster = rail.querySelector('[data-film-poster]');
  var pin = rail.querySelector('.acha-film-pin');
  var captions = Array.prototype.slice.call(rail.querySelectorAll('[data-film-caption]'));
  if (!stage || !canvas) return;

  var count = parseInt(stage.getAttribute('data-film-count'), 10) || 0;
  var extension = stage.getAttribute('data-film-ext') || '.webp';
  var isMobile = window.matchMedia('(max-width: 800px)').matches;
  var need = Math.round(stage.getBoundingClientRect().width * (window.devicePixelRatio || 1));
  // A Retina iPhone can report more than 1000 physical pixels for a 393 CSS px
  // stage. Loading the large sequence in that case makes Safari retain close to
  // 1 GB of decoded frames and causes the sticky animation to stutter.
  var tier = !isMobile && need > 1000 ? 'lg' : 'sm';
  var base = stage.getAttribute('data-film-base-' + tier) || '';
  if (count < 2 || !base) return;

  stage.setAttribute('data-film-tier', tier);

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    rail.setAttribute('data-film-reduced', '');
    rail.style.setProperty('--film-progress', '0');
    return;
  }

  var context = canvas.getContext('2d', { alpha: false });
  if (!context) return;

  var images = new Array(count);
  var decoded = new Array(count);
  var requested = -1;
  var painted = -1;
  var ticking = false;
  var cacheRadius = 14;

  function frameUrl(index) {
    return base + String(index).padStart(3, '0') + extension;
  }

  function paint(index) {
    if (!decoded[index]) return;
    var image = images[index];
    if (!image || !image.naturalWidth) return;

    if (canvas.width !== image.naturalWidth) canvas.width = image.naturalWidth;
    if (canvas.height !== image.naturalHeight) canvas.height = image.naturalHeight;
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    painted = index;
    stage.setAttribute('data-film-frame', String(index));
    if (canvas.hidden) canvas.hidden = false;
    if (poster && !poster.hidden) poster.hidden = true;
  }

  function paintClosestDecoded(index) {
    if (painted < 0) {
      if (decoded[index]) paint(index);
      return;
    }

    var candidate = index;
    var step = index > painted ? -1 : 1;
    while (candidate !== painted && !decoded[candidate]) candidate += step;
    if (candidate !== painted && decoded[candidate]) paint(candidate);
  }

  function markDecoded(index, image) {
    if (images[index] !== image) return;
    decoded[index] = true;
    paintClosestDecoded(requested);
  }

  function load(index, priority) {
    if (index < 0 || index >= count || images[index]) return;

    var image = new Image();
    image.decoding = 'async';
    if (priority) image.fetchPriority = 'high';
    image.src = frameUrl(index);
    images[index] = image;

    if (image.decode) {
      image.decode().catch(function () {
        return new Promise(function (resolve) {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      }).then(function () {
        if (image.naturalWidth) markDecoded(index, image);
      });
    } else {
      image.onload = function () { markDecoded(index, image); };
    }
  }

  function releaseDistantFrames(center) {
    images.forEach(function (image, index) {
      if (!image || index === painted || Math.abs(index - center) <= cacheRadius) return;
      image.onload = null;
      image.src = '';
      images[index] = null;
      decoded[index] = false;
    });
  }

  function progress() {
    var bounds = rail.getBoundingClientRect();
    var pinHeight = pin ? pin.getBoundingClientRect().height : window.innerHeight;
    var travel = bounds.height - pinHeight;
    if (travel <= 0) return 0;
    return Math.max(0, Math.min(1, -bounds.top / travel));
  }

  function updateCaptions(value) {
    if (!captions.length) return;
    var active = Math.min(captions.length - 1, Math.floor(value * captions.length));
    captions.forEach(function (caption, index) {
      caption.toggleAttribute('data-active', index === active);
    });
  }

  function update() {
    ticking = false;
    var value = progress();
    rail.style.setProperty('--film-progress', value.toFixed(4));
    updateCaptions(value);

    var next = Math.round(value * (count - 1));
    requested = next;
    load(next, true);
    for (var offset = 1; offset <= 10; offset += 1) load(next + offset, false);
    for (var previous = 1; previous <= 3; previous += 1) load(next - previous, false);
    releaseDistantFrames(next);
    paintClosestDecoded(next);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  for (var index = 0; index < 8; index += 1) load(index, index === 0);

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  update();
})();
